import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MasonryContainer, MasonryWrapper } from "./ui";
import { MasonryPicture } from "./MasonryPicture";
import { useGalleryContext } from "@/gallery/contexts";
import { MasonryAd } from "@/ads/components/MasonryAd";
export const Masonry = ({ testId, openOnSlideIndex }) => {
    const { masonryItems, galleryCount } = useGalleryContext();
    return (_jsxs(MasonryWrapper, { testId: testId, imagesCount: galleryCount, children: [masonryItems.map((itemDatas, index) => {
                const { type, item } = itemDatas;
                const key = `imageContainer-${type}-${index}`;
                return (_jsx(MasonryContainer, { children: type === "full" ? (_jsx(MasonryPicture, { testId: testId, index: index, openOnSlideIndex: openOnSlideIndex, image: item[0], type: type })) : (_jsx(_Fragment, { children: item.map((image, index) => {
                            return (_jsx(MasonryPicture, { testId: testId, index: index, openOnSlideIndex: openOnSlideIndex, image: image, type: type }, image.key));
                        }) })) }, key));
            }), _jsx(MasonryAd, {})] }));
};
